import React, { Component } from "react"
import { css } from "emotion"
import { Link, navigate } from "gatsby"
import PostImage from "../components/post-image"
/**
 * This class will list the post items
 * @input data and category name
 */
class PostList extends Component {
  getPostPath(node) {
    if (node.slug) {
      return "/" + node.slug
    }
  }

  handleClick(e) {
    if (e.target) {
      let target = e.target

      // loop until finding the link attribute
      while (target.dataset.link == null) {
        target = target.parentNode
      }

      if (target.dataset.link) {
        navigate(target.dataset.link)
      }
    }
  }

  render() {
    const data = this.props.data
    return (
      <>
        <div
          className={css`
            display: flex;
            flex-flow: column wrap;
            justify-content: space-evenly;
            align-items: noraml;

            @media (min-width: 400px) {
              flex-flow: column wrap;
            }

            @media (min-width: 600px) {
              flex-flow: row wrap;
            }

            @media (min-width: 1000px) {
              flex-flow: row wrap;
            }
          `}
        >
          {data.allWordpressPost.edges.map(({ node }) => (
            <div
              data-link={this.getPostPath(node)}
              onClick={this.handleClick}
              key={node.slug}
              className={css`
                padding: 10px;

                @media (min-width: 400px) {
                  flex: 0 1 auto;
                }

                @media (min-width: 600px) {
                  flex: 0 1 45%;
                }

                @media (min-width: 1000px) {
                  flex: 0 1 30%;
                }
              `}
            >
              <PostImage node={node} path={this.getPostPath(node)} />
              <Link
                to={this.getPostPath(node)}
                className={css`
                  text-decoration: none;
                  font-weight: bold;
                  font-size: 22px;
                  color: #000;
                  padding: 10px 0px;
                  display: block;
                `}
              >
                <h3 dangerouslySetInnerHTML={{ __html: node.title }} />
              </Link>
              <div
                onClick={this.handleClick}
                data-link={this.getPostPath(node)}
                dangerouslySetInnerHTML={{ __html: node.excerpt }}
                className={css`
                  font-size: 18px;
                  line-height: 25px;
                `}
              />
            </div>
          ))}
        </div>
      </>
    )
  }
}

export default PostList
